import { ScormPackageModel } from "../scormPackageModel";
import { ScormPackageProgressionModel } from "../scormPackageProgressionModel";
import { UtilisateurFormationModel } from "./utilisateur-formation-model";

export class GroupeFormationModel {
  id!: number;
  entiteId!: number;
  titre!: string;
  commentaire!: string;
  dateHeurePrevue!: Date;
  emplacement!: string;
  dateRetrait!: Date;
  prenomNomAjoutUtilisateurPar!: string;
  prenomNompriseEnChargePar!: string;
  ajouterParUtilisateurId!: number;
  priseEnChargeParUtilisateurId?: number;
  retireParUtilisateurId?: number;
  packageId!: number;
  package!: ScormPackageProgressionModel | null;
  dateCompletee!: Date | null;
  utilisateurs: UtilisateurFormationModel[] = [];
  isMenuOpen: boolean = false;
}
